import apiConfig from "../config/apiConfig";
import { apiFetch } from "../apis/apiFetch";

export const queryAttachmentService = {
  async getAttachment(document_id: string, user_id: string) {
    try {
      const response = await apiFetch(
        `${apiConfig.getResourceUrl('message')}?document_id=${document_id}&queryId=GET_DOCUMENT&dmsRole=admin&user_id=${user_id}`,
        {
          method: "GET",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch attachment");
      }

      return await response.blob();
    } catch (error) {
      console.error("Error fetching attachment:", error);
      throw error;
    }
  },
};
